import {
  Divider,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { MediaDown, MediaUp } from '../../../MediaQueries/MediaQueries';
import DeviceTile, { DeviceTileSkeleton } from './DeviceTile';
import { GatewayDevicesProps } from './types';

const useStyles = makeStyles((theme: Theme) => ({
  deviceRow: {
    margin: theme.spacing(1, 0, 1, 0),
  },
  dividers: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    '& .divider': {
      position: 'relative',
      width: '85%',
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      justifyContent: 'center',

      '& hr': {
        marginLeft: '-1px',
        zIndex: 1,
      },

      '&:first-of-type::before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        backgroundColor: theme.palette.background.paper,
        top: 0,
        left: 0,
        marginLeft: '-1px',
        width: '2px',
        height: 'calc(50% + 1px)',
      },
      '&:last-of-type::after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        backgroundColor: theme.palette.background.paper,
        bottom: 0,
        left: 0,
        marginLeft: '-1px',
        width: '2px',
        height: 'calc(50% + 1px)',
      },
    },
  },
  gatewayContainer: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '-32px',
    },
  },
}));

function GatewayDevices(props: GatewayDevicesProps) {
  const { gateway, loading, unlinkHandler, numberOfDevicesToLink } = props;
  const btDevices = gateway && gateway.sensors ? gateway!.sensors : [];

  const classes = useStyles();

  const renderGateway = () => {
    if (loading) return <DeviceTileSkeleton />;
    return gateway ? (
      <DeviceTile
        device={gateway!}
        isGateway={true}
        disableUnlink={!gateway.sensors?.length}
        className={classes.deviceRow}
        unlinkHandler={unlinkHandler}
      />
    ) : null;
  };

  const renderDevices = () => {
    if (loading) return <DeviceTileSkeleton repeat={numberOfDevicesToLink} />;
    return gateway
      ? btDevices.map((d) => (
          <DeviceTile
            key={d.id}
            device={d}
            className={classes.deviceRow}
            unlinkHandler={unlinkHandler}
          />
        ))
      : null;
  };

  const renderDividers = () => {
    if (loading) {
      return new Array(numberOfDevicesToLink).fill(1).map((_, index) => (
        <div className="divider" key={index}>
          <Divider variant="fullWidth" orientation="horizontal" />
        </div>
      ));
    }
    return gateway
      ? btDevices.map((d) => (
          <div className="divider" key={d.id}>
            <Divider variant="fullWidth" orientation="horizontal" />
          </div>
        ))
      : null;
  };

  const shouldShowDividers = loading
    ? numberOfDevicesToLink
    : gateway && gateway.sensors?.length;
  return (
    <>
      <MediaUp query="sm">
        <Grid container direction="row-reverse">
          <Grid item sm={5}>
            <Typography variant="h6">Sensors</Typography>
          </Grid>
        </Grid>
      </MediaUp>

      <Grid container>
        <Grid
          item
          sm={5}
          container
          direction="column"
          justifyContent="center"
          className={classes.gatewayContainer}
        >
          <Typography variant="h6">Gateway</Typography>
          {renderGateway()}
        </Grid>
        <MediaUp query="sm">
          <Grid
            item
            sm={1}
            container
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
          >
            {shouldShowDividers ? (
              <div style={{ width: '85%' }}>
                <Divider variant="fullWidth" orientation="horizontal" />
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            sm={1}
            container
            direction="column"
            alignItems="flex-start"
            className={shouldShowDividers ? classes.dividers : ''}
          >
            {renderDividers()}
          </Grid>
        </MediaUp>

        <Grid
          item
          sm={5}
          container
          direction="column"
          justifyContent="space-around"
        >
          <MediaDown query="xs">
            <Typography variant="h6">Sensors</Typography>
          </MediaDown>
          {renderDevices()}
        </Grid>
      </Grid>
    </>
  );
}

export default GatewayDevices;
